import {
  Button,
  Center,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spacer,
  Text,
} from "@chakra-ui/react";

export function DeleteModal(props: {
  onDelete: () => void;
  onAbort: () => void;
}) {
  return (
    <Modal closeOnOverlayClick={true} isOpen={true} onClose={props.onAbort}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Bekräfta borttag</ModalHeader>
        <ModalCloseButton />
        <ModalBody margin={"20px"}>
          <Text fontSize={"20px"}>Vill du verkligen ta bort posten?</Text>
          <Center>
            <Text
              textColor={"red"}
              fontWeight={"bold"}
              fontStyle={"italic"}
              fontSize={"16px"}
            >
              (Borttaget går inte att ångra)
            </Text>
          </Center>
        </ModalBody>
        <ModalFooter borderRadius={"0px"} background={"blue.100"}>
          <HStack width={"100%"}>
            <Spacer />
            <Button
              type="button"
              paddingLeft={"40px"}
              paddingRight={"40px"}
              onClick={props.onAbort}
            >
              Avbryt
            </Button>
            <Button type="button" onClick={props.onDelete} colorScheme="red">
              Ta bort
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
